import { removeTelephoneCountryCode, removeZipCodeMask } from '@repo/ui';
import { FormikValues } from 'formik';

const personFormTransformValuesToSubmit = (values: FormikValues) => ({
  name: values.name,
  socialName: values.socialName || null,
  rg: values.rg || null,
  dateOfBirth: values.birth || null,
  gender: values?.gender?.value,
  email: values.email,
  phone: removeTelephoneCountryCode(values.phone) || null,
  address: {
    street: values.street || null,
    number: values.addressNumber || null,
    neighborhood: values.district || null,
    complement: values.addressComplement || null,
    cityId: values?.city?.value || null,
    zipCode: removeZipCodeMask(values.zipcode) || null,
  },
});

export { personFormTransformValuesToSubmit };
